export const DefaultAvatarUrl = './assets/img/avatar.png';
